import React from 'react';
import { Badge, Text, Link, VStack } from "@postenbring/hedwig-react";

const HitUnit = ({hit, hitIndex, localization}) => (
    <VStack gap="8" align="flex-start">
        <Badge size="smaller">{localization.unit.categoryLabel}</Badge>
        <Text variant='h3' as='h2' id={"hit-" + hitIndex}>
            {hit.heading}
        </Text>
        <div id={"hitContent-" + hitIndex}>
            {hit.closingHours?.map(item => ( <p>{item.deadline + ' ' + item.period + ' ' + item.time }</p>))}
            <p>{localization.unit.openingHoursLabel + ': ' + hit.openingHoursDesktop}</p>
            <p>{hit.visitingAddress ? hit.visitingAddress.csv : ''}</p>
        </div>
        <Link href={hit.absoluteUrl} aria-describedby={`hit-${hitIndex} hitContent-${hitIndex}`}>
            {localization.unit.linkLabel}
        </Link>
    </VStack>
);

export default HitUnit;
